import {
	AI_QUESTION1_ID,
	AI_QUESTION1_KEY,
	AI_QUESTION2_ID,
	AI_QUESTION2_KEY, EXPLANATION_TEXT_ID, EXPLANATION_TEXT_KEY,
	NEXT_BUTTON_ID,
	NEXT_BUTTON_KEY,
	PROCESSING_LABEL_ID,
	PROCESSING_LABEL_KEY,
	STATE_ID,
	STATE_KEY,
} from '../constants';

const AI_CONDITIONS = [
	{
		collapsed: false,
		process: 1,
		connector: 'all',
		when: [
			{
				connector: 'AND',
				key: STATE_KEY,
				subId: STATE_ID,
				comparator: 'equal',
				value: 'disabled',
				type: 'field',
				modelType: 'when',
			}],
		then: [
			{
				key: PROCESSING_LABEL_KEY,
				subId: PROCESSING_LABEL_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: EXPLANATION_TEXT_KEY,
				subId: EXPLANATION_TEXT_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION1_KEY,
				subId: AI_QUESTION1_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION2_KEY,
				subId: AI_QUESTION2_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{disclaimer_html}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{i_have_read_the_disclaimer}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{send}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: NEXT_BUTTON_KEY,
				subId: NEXT_BUTTON_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			}],
		else: [],
	},
	{
		collapsed: false,
		process: 1,
		connector: 'all',
		when: [
			{
				connector: 'AND',
				key: STATE_KEY,
				subId: STATE_ID,
				comparator: 'equal',
				value: 'enabled',
				type: 'field',
				modelType: 'when',
			}],
		then: [
			{
				key: STATE_KEY,
				subId: STATE_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: PROCESSING_LABEL_KEY,
				subId: PROCESSING_LABEL_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: EXPLANATION_TEXT_KEY,
				subId: EXPLANATION_TEXT_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION1_KEY,
				subId: AI_QUESTION1_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION2_KEY,
				subId: AI_QUESTION2_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{disclaimer_html}',
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{i_have_read_the_disclaimer}',
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{send}',
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: NEXT_BUTTON_KEY,
				subId: NEXT_BUTTON_ID,
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
		],
		else: [],
	},
	{
		collapsed: false,
		process: 1,
		connector: 'all',
		when: [
			{
				connector: 'AND',
				key: STATE_KEY,
				subId: STATE_ID,
				comparator: 'equal',
				value: 'processing',
				type: 'field',
				modelType: 'when',
			}],
		then: [
			{
				key: STATE_KEY,
				subId: STATE_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: PROCESSING_LABEL_KEY,
				subId: PROCESSING_LABEL_ID,
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: EXPLANATION_TEXT_KEY,
				subId: EXPLANATION_TEXT_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION1_KEY,
				subId: AI_QUESTION1_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION2_KEY,
				subId: AI_QUESTION2_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{disclaimer_html}',
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{i_have_read_the_disclaimer}',
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{send}',
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: NEXT_BUTTON_KEY,
				subId: NEXT_BUTTON_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
		],
		else: [],
	},
	{
		collapsed: false,
		process: 1,
		connector: 'all',
		when: [
			{
				connector: 'AND',
				key: STATE_KEY,
				subId: STATE_ID,
				comparator: 'equal',
				value: 'questions',
				type: 'field',
				modelType: 'when',
			}],
		then: [
			{
				key: STATE_KEY,
				subId: STATE_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: PROCESSING_LABEL_KEY,
				subId: PROCESSING_LABEL_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: EXPLANATION_TEXT_KEY,
				subId: EXPLANATION_TEXT_ID,
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION1_KEY,
				subId: AI_QUESTION1_ID,
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION2_KEY,
				subId: AI_QUESTION2_ID,
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{disclaimer_html}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{i_have_read_the_disclaimer}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{send}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: NEXT_BUTTON_KEY,
				subId: NEXT_BUTTON_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
		],
		else: [],
	},
	{
		collapsed: false,
		process: 1,
		connector: 'all',
		when: [
			{
				connector: 'AND',
				key: STATE_KEY,
				subId: STATE_ID,
				comparator: 'equal',
				value: 'no_questions',
				type: 'field',
				modelType: 'when',
			}],
		then: [
			{
				key: STATE_KEY,
				subId: STATE_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: PROCESSING_LABEL_KEY,
				subId: PROCESSING_LABEL_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: EXPLANATION_TEXT_KEY,
				subId: EXPLANATION_TEXT_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION1_KEY,
				subId: AI_QUESTION1_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: AI_QUESTION2_KEY,
				subId: AI_QUESTION2_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{disclaimer_html}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{i_have_read_the_disclaimer}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: '{send}',
				trigger: 'show_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
			{
				key: NEXT_BUTTON_KEY,
				subId: NEXT_BUTTON_ID,
				trigger: 'hide_field',
				value: '',
				type: 'field',
				modelType: 'then',
			},
		],
		else: [],
	},
];
export default AI_CONDITIONS;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/resources/conditions.js